import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router-dom";
import { translationHookOptions } from "../app/localization/localization";

const NotFoundPage: React.FC<RouteComponentProps> = () => {
  const [t] = useTranslation(["translation"], translationHookOptions);

  return <div>{t("page_not_found")}</div>;
};

export default observer(NotFoundPage);
